// extracted by mini-css-extract-plugin
export default {"title_container":"RecipeFeedBackEditTitle_title_container__T-VM6"};